import api from "@/api";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return state.list || [];
    },
};

const actions = {
    findByName({ commit }, { payload: { query = "none", type = "none", exclude = "none" } }) {
        return api
            .get(
                `/api/goals/list/query/${encodeURIComponent(
                    query,
                )}/type/${type}/exclude/${exclude}`,
            )
            .then(res => {
                const list = res.data || [];
                commit("updateList", { list });
            });
    },
    reset({ commit }) {
        commit("updateList", { list: [] });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
